module.exports = __webpack_public_path__ + "static/media/search-plus.aa221c78.svg";